import { RgTraverse as f, RG_TYPE as i } from "@project-rouge/rg-core";
import { getLevelCount as m } from "../../object-helpers/index3.js";
function d(u) {
  let e = 0;
  return f(u, (n) => {
    if (n.type !== i.Building)
      return;
    const r = n;
    let l = 0;
    const a = m(r, !1);
    for (let t = 0; t < a; t++)
      r.children.some((o) => o.data.level === t && o.type === i.Apartment) && l++;
    return e = Math.max(e, l), !1;
  }), e;
}
export {
  d as getResidentialLevelCount
};
//# sourceMappingURL=index48.js.map
